import React from "react";
import DonatePage from "./components/DonatePage"; // Подключаем страницу доната
import "./App.css"; // Подключаем стили (если нужны)

function App() {
  return (
    <div className="App">
      <DonatePage />
    </div>
  );
}

export default App;
